import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IObraPagedResponse } from "models/response/obra-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type ObrasTableProps = {
    currentItems: PaginationResponse<IObraPagedResponse>;
};

export const ObrasTable: React.FC<ObrasTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhuma obra encontrada.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nº Contrato</TableCell>
                        <TableCell>Tipo de Obra</TableCell>
                        <TableCell>Função</TableCell>
                        <TableCell>Situação</TableCell>
                        <TableCell align="right">Valor</TableCell>
                        <TableCell align="right">% Executado</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((obra) => (
                        <TableRow key={obra.id}>
                            <TableCell>{obra.contratoNumero}</TableCell>
                            <TableCell>
                                <Chip label={obra.tipoObraName} size="small" style={getCategoryColor(obra.tipoObraName)} />
                            </TableCell>
                            <TableCell>{obra.funcaoObraName}</TableCell>
                            <TableCell><Chip label={obra.situacaoObraName} size="small" /></TableCell>
                            <TableCell align="right">
                                {obra.valorObra?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="right">
                                {obra.percentualExecutado !== undefined && obra.percentualExecutado !== null ? `${obra.percentualExecutado}%` : '-'}
                            </TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/obras/${obra.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
